export default "__VITE_ASSET__dy5977po__"